import { mapSrc } from "@/lib/format";

export default function MapEmbed({ query, title }) {
  return (
    <iframe
      title={title || "Map"}
      data-testid="google-map"
      src={mapSrc(query)}
      className="w-full h-[320px] sm:h-[420px] border-0 grayscale-[30%]"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
}
